// sections/PaymentMethodSection/DuitkuRows.tsx — Baris radio per metode Duitku.
import React from 'react';
import PaymentFeeBadge from '../../../../components/PaymentFeeBadge';
import { duitkuShortLabel } from '../../../../constants/duitkuFormMethods';
import { ROW_BASE, ROW_IDLE, ROW_ACTIVE, LOGO_SLOT, duitkuIconClass } from './rowClasses';

export const DuitkuRows: React.FC<{
    methods: { value: string }[]; selectedPaymentKey: unknown; selectedDuitkuMethod: unknown;
    setSelectedPaymentKey: (v: any) => void; setSelectedDuitkuMethod: (v: any) => void;
    duitkuIconFor: (method: string) => React.FC<{ className?: string }>;
}> = ({ methods, selectedPaymentKey, selectedDuitkuMethod, setSelectedPaymentKey, setSelectedDuitkuMethod, duitkuIconFor }) => (
    <>
        {methods.map(m => {
            const active = selectedPaymentKey === 'duitku' && selectedDuitkuMethod === m.value;
            const Icon = duitkuIconFor(m.value);
            return (<div key={`duitku:${m.value}`}>
                <label className={ROW_BASE + (active ? ROW_ACTIVE : ROW_IDLE)}>
                    <input type="radio" name="paymentMethod" value={m.value} checked={active} onChange={() => { setSelectedPaymentKey('duitku'); setSelectedDuitkuMethod(m.value); }} className="h-4 w-4 text-orange-600" />
                    <span className={LOGO_SLOT}><Icon className={duitkuIconClass(Icon)} /></span>
                    <div className="flex-1 min-w-0">
                        <span className="font-medium">{duitkuShortLabel(m.value)}</span>
                    </div>
                    <PaymentFeeBadge method={m.value} />
                </label>
            </div>);
        })}
    </>
);
